import { formatDataBeforeSend } from "helpers/GeneralHelper";
import { useUserContext } from "libs/context/UserContext";
import { candidateAcceptRoadTest, candidateRejectRoadTest } from "model/CandidateDetailsModel";
import { updateFetchDetails } from "model/Partners";
import React, { useState } from "react";
import {
    Button,
    Modal,
    ModalBody,
    Spinner,
} from "reactstrap";
import { toast, ToastContainer } from "react-toastify";


const RoadTestModalSection = ({ setSidebarOpen, sidebarOpen, testDateDateTimeValue, roadTestRawStatus }) => {
    const { candidateDetailsData, fetchCandidateDetailsDataForUpdate, fetchCandidateDetailsData } = useUserContext() || {};
    const inputFields = {
    };
    const formatOptions = [];
    const [fields, setFields] = useState(inputFields);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [submitLoadingReject, setSubmitLoadingReject] = useState(false);
    const closeModal = (e) => {
        e.preventDefault();
        setSidebarOpen(false);
    };

    const acceptOrRejectRoadSchedule = async (e, status) => {
        e.preventDefault();
        if (status == 'accepted') {
            setSubmitLoading(true);
        }
        else if (status == 'rejected') {
            setSubmitLoadingReject(true)
        }

        try {
            const formData = formatDataBeforeSend(fields, inputFields, formatOptions);
            formData.append('candidateClientId', candidateDetailsData?.candidateClientId)
            formData.append('Status', (status == 'rejected' ? 'cancelled' : 'accepted'))

            let response;
            if (status == 'accepted') {
                response = await candidateAcceptRoadTest(formData)
            }
            else if (status == 'rejected') {
                response = await candidateRejectRoadTest(formData)
            }

            if (response?.Message) {
                toast.success(response?.Message);
                fetchCandidateDetailsDataForUpdate()
                // fetchCandidateDetailsData()
                setSubmitLoading(false);
                setSubmitLoadingReject(false)
                setSidebarOpen(false);
            } else {
                toast.error("Failed to update");
            }
        } catch (err) {
            toast.error(err);
        } finally {
            setSubmitLoading(false);
            setSubmitLoadingReject(false)
        }
    };

    return (
        <>
            <Modal
                isOpen={sidebarOpen}
                className="modal-dialog-left modal-full-height"
                backdrop="static"
            >
                <ModalBody className="p-0" style={{ maxHeight: "95vh", overflowY: "auto" }}
                >
                    {/* Header */}
                    <div className="d-flex justify-content-between align-items-center px-3 py-2 border-bottom bg-white">
                        <h5 className="fw-bold mb-0 mx-auto">Road test</h5>
                        <Button close onClick={(e) => closeModal(e)} />
                    </div>

                    {/* Scrollable Tabs (empty but preserved) */}
                    <div className="d-flex align-items-center">
                    </div>

                    {/* Tab Content */}
                    <div className="p-3">
                        {/* Info Card */}
                        <div className="border rounded p-3 text-center bg-light mb-3">
                            {(roadTestRawStatus && roadTestRawStatus == 'pending') &&
                                <p className="mb-0">
                                    Road Test already Scheduled. <br />
                                    <span className="text-muted">(Date: {testDateDateTimeValue})</span>
                                </p>
                            }
                             {(roadTestRawStatus && roadTestRawStatus == 'completed') &&
                                <p className="mb-0">
                                    <strong>Road Test completed.</strong> <br />
                                </p>
                            }
                            {roadTestRawStatus && roadTestRawStatus == 'accepted' &&
                                <p className="mb-0">
                                    Road Test Accepted. <br />
                                    <span className="text-muted">(Date: {testDateDateTimeValue})</span>
                                </p>}
                        </div>


                        {/* Action Buttons */}
                        {(roadTestRawStatus && roadTestRawStatus == 'pending') &&
                        <div className="d-flex justify-content-center gap-3">
                            <Button color="dark" className="px-4" onClick={(e) => acceptOrRejectRoadSchedule(e, 'accepted')}>
                                {submitLoading ? (
                                    <>
                                        <Spinner
                                            size="sm"
                                            className="me-2"
                                        />
                                        Loading...
                                    </>
                                ) : (
                                    "Accept"
                                )}
                            </Button>
                            <Button outline color="secondary" className="px-4" onClick={(e) => acceptOrRejectRoadSchedule(e, 'rejected')}>
                                {submitLoadingReject ? (
                                    <>
                                        <Spinner
                                            size="sm"
                                            className="me-2"
                                        />
                                        Loading...
                                    </>
                                ) : (
                                    "Cancel"
                                )}
                            </Button>
                        </div>
}
                    </div>
                </ModalBody>
            </Modal>
        </>
    );
};

export default RoadTestModalSection;
